export default __webpack_public_path__ + "static/media/Oculus_mockup.fcd004a8.png";